
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.491 0H2.508a.633.633 0 00-.633.633v22.734c0 .35.284.633.633.633H21.49a.633.633 0 00.633-.633V.633A.634.634 0 0021.49 0zm-.633 22.734H3.141V6.11h17.717v16.624z"}}),_c('path',{attrs:{"d":"M5.672 11.112h12.655a.316.316 0 00.317-.316V8.645a.316.316 0 00-.317-.317H5.672a.316.316 0 00-.317.317v2.151c0 .175.142.316.317.316zM5.672 20.418h5.758a.316.316 0 00.316-.317V14.09a.316.316 0 00-.316-.317H5.672a.316.316 0 00-.317.317V20.1c0 .175.142.317.317.317zM18.328 13.773h-4.43a.316.316 0 00-.316.317v1.835c0 .175.142.316.316.316h4.43a.316.316 0 00.316-.316V14.09a.316.316 0 00-.316-.317zM18.328 17.863h-4.43a.316.316 0 00-.316.317v1.835c0 .174.142.316.316.316h4.43a.316.316 0 00.316-.316V18.18a.316.316 0 00-.316-.317z"}})])
          )
        }
      }
    